'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StylishButton = /** @class */ (function (_super) {
    __extends(StylishButton, _super);
    function StylishButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isActivated: false,
            isHovered: false,
            isFocused: false,
        };
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleMouseUp = _this.handleMouseUp.bind(_this);
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        return _this;
    }
    /**
     * Handles setting the button as being Active.
     */
    StylishButton.prototype.handleMouseDown = function (event) {
        if (event.button !== 0) {
            return;
        }
        this.setState({ isActivated: true });
    };
    /**
     * Handles setting the button as not being Active.
     */
    StylishButton.prototype.handleMouseUp = function (event) {
        if (event.button !== 0) {
            return;
        }
        this.setState({ isActivated: false });
    };
    /**
     * Handles setting the button as being Hovered.
     */
    StylishButton.prototype.handleMouseEnter = function (event) {
        this.setState({ isHovered: true });
    };
    /**
     * Handles setting the button as not being Hovered.
     */
    StylishButton.prototype.handleMouseLeave = function (event) {
        this.setState({ isHovered: false });
    };
    /**
     * Handles setting the button as being Focused.
     */
    StylishButton.prototype.handleFocus = function (event) {
        this.setState({ isFocused: true });
    };
    /**
     * Handles setting the button as not being Focused.
     */
    StylishButton.prototype.handleBlur = function (event) {
        this.setState({ isFocused: false });
    };
    StylishButton.prototype.render = function () {
        var events = {};
        if (this.props.styles[':hover'] !== undefined) {
            events.onMouseEnter = this.handleMouseEnter;
            events.onMouseLeave = this.handleMouseLeave;
        }
        if (this.props.styles[':active'] !== undefined) {
            events.onMouseDown = this.handleMouseDown;
            events.onMouseUp = this.handleMouseUp;
        }
        if (this.props.styles[':focus'] !== undefined) {
            events.onFocus = this.handleFocus;
            events.onBlur = this.handleBlur;
        }
        var styles = __assign({}, this.props.styles.base);
        if (this.state.isHovered) {
            styles = __assign({}, styles, this.props.styles[':hover']);
        }
        if (this.state.isActivated) {
            styles = __assign({}, styles, this.props.styles[':active']);
        }
        if (this.state.isFocused) {
            styles = __assign({}, styles, this.props.styles[':focus']);
        }
        return (React.createElement("button", __assign({ id: this.props.id, style: styles }, this.props.events, events), this.props.text));
    };
    return StylishButton;
}(React.Component));
exports.StylishButton = StylishButton;
//# sourceMappingURL=StylishButton.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/StylishButton.js
// module id = 7
// module chunks = 0